module.exports = __webpack_public_path__ + "static/media/Ruby-blinking.81146b86.png";